import axios from 'axios'
import apiUrl from '../../api.config'
const API_URL = apiUrl

class AuthService {
    login(user) {
        return axios
            .post(API_URL + 'auth/login', {
                username: user.username,
                password: user.password,
            })
            .then((response) => {
                if (response.data.accessToken) {
                    localStorage.setItem('accessToken', response.data.accessToken)
                    localStorage.setItem('user_id', response.data.user_id)
                    localStorage.setItem('name', response.data.name)
                    localStorage.setItem('userType', response.data.userType)
                    localStorage.setItem("authenticated", true);
                }
                return response.data
            })
            .catch((err) => {
                throw err.response.data
            })
    }

    logout() {
        localStorage.removeItem("authenticated");
        return axios.post(API_URL + 'auth/logout',{}, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
            .then((response) => {
                localStorage.removeItem('accessToken')
                localStorage.removeItem('user_id')
                localStorage.removeItem('name')
                localStorage.removeItem('userType')

                return response.data
            })
            .catch((err) => {
                throw err.response.data
            })
    }

    verifyToken() {
        return axios.post(API_URL + 'auth/verifyToken', {}, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
}

export default new AuthService()